import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PlanAssemblyIntroProps {
  onNext: () => void;
  onClose: () => void;
}

export function PlanAssemblyIntro({ onNext, onClose }: PlanAssemblyIntroProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-8 py-12">
      <div className="max-w-lg text-center space-y-6">
        <div className="mx-auto w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <FileText className="h-7 w-7 text-primary" />
        </div>

        <h2 className="text-2xl font-semibold text-foreground">
          Your succession plan is ready to be built.
        </h2>

        <p className="text-muted-foreground text-[15px] leading-relaxed">
          You've completed all 10 assessments. We've analyzed your business across five key
          dimensions. What follows is your personalized mySuccession Plan — a living document
          you can refine and act on.
        </p>

        <Button onClick={onNext} className="bg-primary hover:bg-primary/90 mt-4">
          Build My Plan →
        </Button>
      </div>
    </div>
  );
}
